<template>
    <div class="my-items">
        <template v-if="myItems.length">
            <div class="count-wrap" v-if="localType !== 'transfer'" :style="{background:' linear-gradient(45deg, '+mainColorLight+', '+mainColorDarken+')'}">
                <template v-if="receive">
                    <div class="count-item" :class="{active: filter=='todo'}" @click="onCountItemClick('todo')">
                        <h3 class="num-todo">{{sumtodo}}</h3>
                        <span>待办总数</span>
                    </div>
                    <div class="count-item" :class="{active: filter=='done'}" @click="onCountItemClick('done')">
                        <h3 class="num-done">{{sumdone}}</h3>
                        <span>已办总数</span>
                    </div>
                    <div class="count-item" :class="{active: filter=='copy'}" @click="onCountItemClick('copy')">
                        <h3 class="num-copy">{{sumcopy}}</h3>
                        <span>抄送总数</span>
                    </div>
                </template>
                <template v-else>
                    <div class="count-item" :class="{active: filter=='ongoing'}" @click="onCountItemClick('ongoing')">
                        <h3 class="num-ongoing">{{sumongoing}}</h3>
                        <span>进行中总数</span>
                    </div>
                    <div class="count-item" :class="{active: filter=='end'}" @click="onCountItemClick('end')">
                        <h3 class="num-end">{{sumend}}</h3>
                        <span>已结束总数</span>
                    </div>
                    <div class="count-item" :class="{active: filter=='draft'}" @click="onCountItemClick('draft')">
                        <h3 class="num-draft">{{sumdraft}}</h3>
                        <span>草稿箱总数</span>
                    </div>
                </template>
            </div>

            <div v-if="!!filter" class="ht-text-assist filter-hint"
                 @click="onCloseFilter">
                <van-icon name="filter-o"/>
                已开启筛选，点击关闭
            </div>

            <form action="javascript:void(0)">
                <van-search
                        background="#fff"
                        v-model="keyword"
                        placeholder="请输入搜索关键词"
                        :clearable="false"
                />
            </form>

            <div class="item-wrap" :class="{'ht-empty': !parsedMyItems.length}" v-if="parsedMyItems.length">
              <van-list
                  v-model="loading"
                  :finished="finished"
                  :error.sync="error"
                  error-text="请求失败，点击重新加载"
                  @load="queryData"
              >
                <MyItem v-for="(item, index) in parsedMyItems" :key="index" :item="item" :receive="receive" :localType="localType"/>
              </van-list>
            </div>
          <div class="empty-container" v-else>
            <Error type="empty"/>
          </div>

            <p class="recount-wrap" @click="recountClickHandler">
                <van-icon name="replay" :size="22"/>
                <span class="recount-btn">刷新数据</span>
            </p>
        </template>
    </div>
</template>

<script>
import {
    queryReceivedItemList,
    querySentItemList,
    queryTotalItemNum,
    recountTotalItemNum,
    recountTodoItemNum
} from "@/api/my-items";
import MyItem from "@/components/MyItems/MyItem"
import {List, Icon, Toast, Loading, Search} from 'vant'
import {getThemeParams} from "@/utils/theme";
import {fetchRgbColer} from "@/utils/commons";

export default {
    name: 'MyItems',
    components: {
        MyItem,
        [List.name]: List,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [Search.name]: Search,
    },
    data() {
        return {
            keyword: '',
            localType: '',
            myItems: [],
            sumtodo: 0,
            sumdone: 0,
            sumcopy: 0,
            sumongoing: 0,
            sumend: 0,
            sumdraft: 0,
            filter: '',
            loading: false,
            finished: true,
            error: false,
            emptyShow: false //空空如也是否显示
        }
    },
    computed: {
        receive() {
            return this.localType === 'receive'
        },
        parsedMyItems() {
            return this.myItems.filter(item => {
                let result = true
                if (this.keyword) result = result && item.bname.includes(this.keyword)
                if (this.filter) result = result && item[this.filter] > 0
                if (!this.myItems.length){
                  this.emptyShow = true;
                } else {
                  this.emptyShow = false;
                }
                return result
            })
        },
      mainColor() {
        if (getThemeParams('main_color')){
          return getThemeParams('main_color');
        } else {
          return '#003c88'
        }
      },
      mainColorLight() {
        let rgb = fetchRgbColer(this.mainColor)
        return 'rgba(' + rgb.join(',') + ',0.7)'
      },
      mainColorDarken() {
        let rgb = fetchRgbColer(this.mainColor)
        rgb[0]-=20;
        rgb[1]-=20;
        rgb[2]-=20;
        return 'rgba(' + rgb.join(',') + ',1)'
      }
    },
    props: ['type'],
    created() {
        recountTotalItemNum()
        recountTodoItemNum()
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.localType = to.params.type
            vm.queryData()
        })
    },
    beforeRouteUpdate(to, from, next) {
        this.keyword = ''
        this.localType = to.params.type
        this.filter = ''
        this.queryData()
        next()
    },
    methods: {
        queryData() {
            this.loading = true;
            this.myItems = []
            let promise = this.receive ? queryReceivedItemList() : querySentItemList()
            promise.then(resp => {
                this.myItems = resp.data
                this.loading = false
            }).catch(error => {
              this.loading = false
              this.error = true
            }).finally(() => {
              this.loading = false
              // TODO：处理请求完成的结果
            })

            queryTotalItemNum().then(resp => {
                this.sumtodo = this.parseNum(resp.sumtodo)
                this.sumdone = this.parseNum(resp.sumdone)
                this.sumcopy = this.parseNum(resp.sumcopy)
                this.sumongoing = this.parseNum(resp.sumongoing)
                this.sumend = this.parseNum(resp.sumend)
                this.sumdraft = this.parseNum(resp.sumdraft)
            });
        },
        recountClickHandler() {
            recountTotalItemNum()
            Toast.loading({
                message: '正在重算...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 3000,
                onClose: () => window.location.reload()
            })
        },
        onCountItemClick(key) {
            if (this.filter == key) {
                this.onCloseFilter()
            } else {
                this.filter = key
                Toast('已开启筛选')
            }
        },
        parseNum(num) {
            if (!num) return num
            if (typeof num == 'string') num = parseInt(num)
            if (num > 9999) num = '9999+'
            return num
        },
        onCloseFilter(){
            this.filter = ''
            Toast('已关闭筛选')
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
// 主题色
$color-theme: #1678ff;//var(--main-color);
$color-light-theme: lighten($color-theme, 10%);
$color-dark-theme: darken($color-theme, 10%);

.van-search {
    border-radius: 6px;
    padding: 0;
    margin-bottom: 10px;
    .van-search__content{
      background-color: inherit;
    }
}

.my-items {
    padding: 0 15px 10px;

    .count-wrap {
        display: flex;
        justify-content: space-around;
        padding: 0;
        margin-bottom: 10px;
        border-radius: 6px;
        //background: linear-gradient(45deg, $color-light-theme, $color-dark-theme);
        overflow: hidden;
        .count-item {
            text-align: center;
            padding: 20px 0;
            flex-grow: 1;
            flex-shrink: 0;

            &.active {
                background-color: rgba(0, 0, 0, .1);
            }

            h3 {
                font-weight: 600;
                line-height: 1.2;
                text-align: center;
                -webkit-user-select: none;
                user-select: none;
                @extend .font28;
            }

            span {
                color: #ffffff;
                -webkit-user-select: none;
                user-select: none;
                @extend .font12;
            }
        }
    }

    .num-todo,
    .num-done,
    .num-copy,
    .num-ongoing,
    .num-end,
    .num-draft {
        color: #ffffff;
    }

    .recount-wrap {
        padding: 10px 15px;
        font-size: 14px;
        color: #666;
        display: flex;
        align-items: center;
        justify-content: center;
        @extend .font14;
    }

    .filter-hint {
        text-align: center;
        margin-bottom: 10px;
        @extend .font12;
    }
}
</style>
